// extracted by mini-css-extract-plugin
module.exports = {"regular":"ChartDot_regular__1VS4V","normal":"ChartDot_normal__32W-C","medium":"ChartDot_medium__-gT41","high":"ChartDot_high__q8WjE","highest":"ChartDot_highest__qch63"};